import { gsap, Power2 } from "gsap";

document.addEventListener('DOMContentLoaded', function () {
    // Tweenmax
    let tl = gsap.timeline();
    tl.fromTo('#intro, #video', .6, { css: { opacity: 0 }, ease: Power2.easeOut }, { css: { opacity: 1 } })
        .from('h1', .9, { y: '30', autoAlpha: 0, ease: Power2.easeOut }, ".3")
        .fromTo('.dutchlabel span', .9, { css: { opacity: 0 }, ease: Power2.easeOut }, { css: { opacity: 1 } }, "-=.6")
        .fromTo('#breadcrumbs', .3, { css: { opacity: 0 }, ease: Power2.easeOut }, { css: { opacity: 1 } }, "-=.6")
        .fromTo('.pattern', .3, { ease: Power2.easeOut }, { autoAlpha: .4 })
        .fromTo('#cta', .3, { css: { opacity: 0 }, ease: Power2.easeOut }, { css: { opacity: 1 } }, "-=.6")
        .fromTo('#content', .3, { y: '30', css: { opacity: 0 }, ease: Power2.easeOut }, { css: { opacity: 1 } }, "-=.9")
}, false);
